import React from 'react';
import { Link } from 'react-router-dom';

/** Direct guide links stay safe while the architecture documentation is updated. */
export function ReportsGuideUnavailablePage(): React.ReactElement {
  return (
    <main className="mx-auto max-w-2xl space-y-4 px-6 py-12">
      <h1 className="text-2xl font-semibold">Report guide is being updated</h1>
      <p className="text-text-secondary">We are updating this guide to reflect the current decision workflow.</p>
      <Link to="/" className="text-primary underline">Return to dashboard</Link>
    </main>
  );
}
